// extracted by mini-css-extract-plugin
export default {"inputArea":"RemoveDuplicate_inputArea__lVhwi","outputArea":"RemoveDuplicate_outputArea__dP3jm","text":"RemoveDuplicate_text__afby-"};